import {requirePermission} from '@/modules/auth/permissions'
import {useGetInfiniteCompoundOrders} from '@/modules/smart-compounders/api/use-get-infinite-compound-orders'
import {OrdersTable} from '@/modules/smart-compounders/components/orders-table'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

const LIMIT = 25

export const Route = createFileRoute('/configuration/smart-compounders/orders')({
  beforeLoad: requirePermission('interfaces.manage'),
  component: OrdersPage,
})

function OrdersPage() {
  const {t} = useTranslate('common')
  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = useGetInfiniteCompoundOrders({limit: LIMIT})

  return (
    <ResourcesIndexPageTable>
      <ResourcesIndexPageHeader title={t('compound_orders')} description={t('compound_orders_description')} />
      <OrdersTable virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}} table={{}} />
    </ResourcesIndexPageTable>
  )
}
